<div class="person-view-container">

  @if (loading) {
    <div class="loading-overlay">
      <mat-spinner diameter="60"></mat-spinner>
      <p>Loading person...</p>
    </div>
  }

  @if (error) {
    <mat-card class="error-card">
      <mat-card-content>
        <mat-icon color="warn">error</mat-icon>
        <h2>{{ error }}</h2>
        <button mat-raised-button color="primary" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Return to People
        </button>
      </mat-card-content>
    </mat-card>
  }

  @if (!loading && !error && currentPerson) {

    <mat-sidenav-container class="sidenav-container">

      <!-- Actions Sidenav (Left Side) -->
      <mat-sidenav mode="side" opened position="start" class="actions-sidenav">
        <app-entity-actions-sidenav
          title="Person Actions"
          [actions]="sidenavActions"
          [tabs]="sidenavTabs"
          [selectedTabIndex]="selectedTabIndex"
          (tabSelected)="selectTab($event)">
        </app-entity-actions-sidenav>
      </mat-sidenav>

      <!-- Main Content -->
      <mat-sidenav-content class="form-content">

        <!-- Header Actions Bar -->
        <div class="header-bar">
          <button mat-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Back to People
          </button>

          <div class="header-actions">
            <button mat-raised-button color="primary" (click)="editPerson()">
              <mat-icon>edit</mat-icon>
              Edit Person
            </button>
          </div>
        </div>

        <!-- Static Information Section (Always Visible) -->
        <div class="static-info-section">
          <!-- Person Name Header -->
          <div class="person-name-header">
            <h1>{{ currentPerson.fullName || 'N/A' }}</h1>
            <div class="person-metadata">
              <span class="contact-num">Contact ID: {{ currentPerson.contactNum || '' }}</span>
            </div>
          </div>

          <!-- Essential Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>person</mat-icon>
              <h3>Essential Information</h3>
            </div>
            <div class="info-grid essential-grid">
              <div class="info-field">
                <label>First Name</label>
                <div class="value">{{ currentPerson.firstName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Middle Name</label>
                <div class="value">{{ currentPerson.middleName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Last Name</label>
                <div class="value">{{ currentPerson.lastName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Prefix</label>
                <div class="value">{{ currentPerson.prefix || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Suffix</label>
                <div class="value">{{ currentPerson.suffix || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Salutation</label>
                <div class="value">{{ currentPerson.salutation || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Title</label>
                <div class="value">{{ currentPerson.title || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Function</label>
                <div class="value">{{ currentPerson.function || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Department</label>
                <div class="value">{{ currentPerson.department || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Primary Vendor</label>
                <div class="value">{{ primaryVendorName }}</div>
              </div>

              <div class="info-field">
                <label>Friendly Name</label>
                <div class="value">{{ currentPerson.friendlyName || 'N/A' }}</div>
              </div>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>contact_phone</mat-icon>
              <h3>Contact Information</h3>
            </div>
            <div class="info-grid contact-grid">
              <div class="info-field">
                <label>Email</label>
                <div class="value">{{ currentPerson.email || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Secondary Email</label>
                <div class="value">{{ currentPerson.email2 || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Primary Phone</label>
                <div class="value">{{ currentPerson.primaryPhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Office Phone</label>
                <div class="value">{{ currentPerson.officePhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Mobile Phone</label>
                <div class="value">{{ currentPerson.mobilePhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Secondary Phone</label>
                <div class="value">{{ currentPerson.secondaryPhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Fax Phone</label>
                <div class="value">{{ currentPerson.faxPhone || 'N/A' }}</div>
              </div>
            </div>
          </div>

          <!-- Address Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>location_on</mat-icon>
              <h3>Address Information</h3>
            </div>
            <div class="info-grid address-grid">
              <div class="info-field full-width">
                <label>Primary Address</label>
                <div class="value">{{ currentPerson.address || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>City</label>
                <div class="value">{{ currentPerson.city || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>State</label>
                <div class="value">{{ currentPerson.state || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>ZIP Code</label>
                <div class="value">{{ currentPerson.zip || 'N/A' }}</div>
              </div>

              <div class="info-field full-width">
                <label>Secondary Address</label>
                <div class="value">{{ currentPerson.secondaryAddress || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Secondary City</label>
                <div class="value">{{ currentPerson.secondaryCity || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Secondary State</label>
                <div class="value">{{ currentPerson.secondaryState || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Secondary ZIP</label>
                <div class="value">{{ currentPerson.secondaryZip || 'N/A' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabbed Content -->
        <mat-tab-group
          [selectedIndex]="selectedTabIndex"
          (selectedIndexChange)="selectTab($event)"
          class="person-tabs">

          <!-- Tab 0: Details -->
          <mat-tab label="Details">
            <div class="tab-content">
              <mat-card class="info-card">
                <mat-card-header>
                  <mat-card-title>
                    <mat-icon>info</mat-icon>
                    Additional Person Information
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="info-grid additional-grid">
                    <div class="info-field full-width">
                      <label>Description</label>
                      <div class="value">{{ currentPerson.description || 'N/A' }}</div>
                    </div>

                    <div class="info-field full-width">
                      <label>Other Information</label>
                      <div class="value">{{ currentPerson.other || 'N/A' }}</div>
                    </div>

                    <div class="info-field">
                      <label>Primary Responsible Party</label>
                      <div class="value">{{ primaryOwnerName }}</div>
                    </div>

                    <div class="info-field">
                      <label>Primary Vendor Friendly Name</label>
                      <div class="value">{{ currentPerson.primaryVendorFriendlyName || 'N/A' }}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>

          <!-- Tab 1: Contracts -->
          <mat-tab label="Contracts">
            <div class="tab-content">
              @if (currentPerson.contracts && currentPerson.contracts.length > 0) {
                <app-contract-connections
                  [selectedContractList]="currentPerson.contracts">
                </app-contract-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>description</mat-icon>
                    <p>No contracts associated with this person</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 2: BAAs -->
          <mat-tab label="BAAs">
            <div class="tab-content">
              @if (currentPerson.baas && currentPerson.baas.length > 0) {
                <app-baa-connections
                  [selectedBaaList]="currentPerson.baas">
                </app-baa-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>policy</mat-icon>
                    <p>No Business Associate Agreements associated with this person</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 3: COIs -->
          <mat-tab label="COIs">
            <div class="tab-content">
              @if (currentPerson.cois && currentPerson.cois.length > 0) {
                <app-coi-connections
                  [selectedCoiList]="currentPerson.cois">
                </app-coi-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>verified_user</mat-icon>
                    <p>No Certificates of Insurance associated with this person</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 4: Vendors -->
          <mat-tab label="Vendors">
            <div class="tab-content">
              @if (currentPerson.vendors && currentPerson.vendors.length > 0) {
                <app-vendor-connections
                  [selectedVendorList]="currentPerson.vendors">
                </app-vendor-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>business</mat-icon>
                    <p>No vendors associated with this person</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 5: Parties -->
          <mat-tab label="Parties">
            <div class="tab-content">
              <mat-card class="empty-state">
                <mat-card-content>
                  <mat-icon>groups</mat-icon>
                  <p>Parties content coming soon</p>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>

          <!-- Tab 6: People -->
          <mat-tab label="People">
            <div class="tab-content">
              @if (currentPerson.people && currentPerson.people.length > 0) {
                <mat-card class="info-card">
                  <mat-card-content>
                    <p>Related People: {{ currentPerson.people.length }}</p>
                    <!-- TODO: Add people connections component -->
                  </mat-card-content>
                </mat-card>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>person</mat-icon>
                    <p>No related people for this person</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 7: Attachments -->
          <mat-tab label="Attachments">
            <div class="tab-content">
              @if (entityAttachments && entityAttachments.length > 0) {
                <app-attachment-connections
                  [attachmentObjectArray]="entityAttachments"
                  (attachmentUpdated)="refreshAttachments()">
                </app-attachment-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>attach_file</mat-icon>
                    <p>No attachments for this person</p>
                    <button mat-raised-button color="primary" (click)="addAttachment()">
                      <mat-icon>add</mat-icon>
                      Add Attachment
                    </button>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 8: Important Dates -->
          <mat-tab label="Important Dates">
            <div class="tab-content">
              @if (entityDates && entityDates.length > 0) {
                <app-critical-date-connections
                  [dateObjectArray]="entityDates"
                  (criticalDateUpdated)="refreshCriticalDates()">
                </app-critical-date-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>event</mat-icon>
                    <p>No important dates for this person</p>
                    <button mat-raised-button color="primary" (click)="addCriticalDate()">
                      <mat-icon>add</mat-icon>
                      Add Important Date
                    </button>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 9: Notes -->
          <mat-tab label="Notes">
            <div class="tab-content">
              <app-notes
                [notes]="currentPerson?.notes || []"
                (notesSaved)="saveNotes($event)">
              </app-notes>
            </div>
          </mat-tab>

          <!-- Tab 10: Risk Assessments -->
          <mat-tab label="Risk Assessments">
            <div class="tab-content">
              <mat-card class="empty-state">
                <mat-card-content>
                  <mat-icon>assessment</mat-icon>
                  <p>Risk Assessments content coming soon</p>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>

        </mat-tab-group>

      </mat-sidenav-content>

    </mat-sidenav-container>

  }

</div>
